function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "<Gruppe>"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "<Pfad>",
  d: "M152.43 120.17c8.36 14.79 1.57 27.72-15.2 27.72H22.77c-16.72 0-23.57-12.93-15.2-27.72L64.8 15.04c8.33-14.34 22-15.1 30.41 0z"
}));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "<Pfad>",
  d: "M80 43.89v56.5"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 80,
  cy: 119.89,
  r: 2
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 80,
  cy: 119.89,
  r: 2
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 80,
  cy: 119.89,
  r: 1
});

var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "ICON",
    viewBox: "0 0 160 151.89",
    "aria-hidden": true
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
};

export default SvgWarning;